export enum PMQueries {
  PMTable = 'pMTable',
}
